import { validatePayload, requiredNonEmptyString, nonEmptyString, } from '../../utils/validate-payload.js';
import { documentIdentifier, makeAnalyticsAction, partialDocumentInformation, validateResultPayload, } from './analytics-utils.js';
import { SearchPageEvents } from './search-action-cause.js';
const validateEvent = (p) => validatePayload(p, {
    evt: requiredNonEmptyString,
    type: nonEmptyString,
});
export const logSearchEvent = (p) => makeAnalyticsAction('analytics/generic/search', (client) => {
    validateEvent(p);
    const { evt, meta } = p;
    return client.makeSearchEvent(evt, meta);
});
export const logClickEvent = (p) => makeAnalyticsAction('analytics/generic/click', (client, state) => {
    validateResultPayload(p.result);
    validateEvent(p);
    return client.makeClickEvent(p.evt, partialDocumentInformation(p.result, state), documentIdentifier(p.result), p.meta);
});
export const logCustomEvent = (p) => makeAnalyticsAction('analytics/generic/custom', (client) => {
    validateEvent(p);
    return client.makeCustomEventWithType(p.evt, p.type, p.meta);
});
//TODO: KIT-2859
export const logInterfaceLoad = () => makeAnalyticsAction('analytics/interface/load', (client) => client.makeInterfaceLoad());
//TODO: KIT-2859
export const logInterfaceChange = () => makeAnalyticsAction('analytics/interface/change', (client, state) => client.makeInterfaceChange({
    interfaceChangeTo: state.configuration.analytics.originLevel2,
}));
//TODO: KIT-2859
export const logSearchFromLink = () => makeAnalyticsAction('analytics/interface/searchFromLink', (client) => client.makeSearchFromLink());
//TODO: KIT-2859
export const logOmniboxFromLink = (metadata) => makeAnalyticsAction('analytics/interface/omniboxFromLink', (client) => client.makeOmniboxFromLink(metadata));
// --------------------- KIT-2859 : Everything above this will get deleted ! :) ---------------------
export const interfaceLoad = () => ({
    actionCause: SearchPageEvents.interfaceLoad,
});
export const interfaceChange = () => ({
    actionCause: SearchPageEvents.interfaceChange,
});
export const searchFromLink = () => ({
    actionCause: SearchPageEvents.searchFromLink,
});
export const omniboxFromLink = () => ({
    actionCause: SearchPageEvents.omniboxFromLink,
});
